import { Culture } from "@/types/setting.types";

export enum FocusKeyEnum {
  QUALITY_DRAWER = "QUALITY_DRAWER",
  QUALITY_DRAWER_ITEM = "QUALITY_DRAWER_ITEM",
  SUBTITLE_DRAWER = "SUBTITLE_DRAWER",
  SUBTITLE_DRAWER_ITEM = "SUBTITLE_DRAWER_ITEM",
  SPEED_DRAWER = "SPEED_DRAWER",
  SEEKBAR_FOCUS_KEY = "SEEKBAR",
  SPEED_DRAWER_ITEM = "SPEED_DRAWER_ITEM",
  MY_LIST_PRIMARY_BUTTON = "MY_LIST_PRIMARY_BUTTON",
  MY_LIST_SECONDARY_BUTTON = "MY_LIST_SECONDARY_BUTTON",
  // Profile Creation/Edit Focus Keys
  CREATE_PROFILE_CONTAINER = "CREATE_PROFILE_CONTAINER",
  PROFILE_NAME_INPUT = "profile-name-input",
  LANGUAGE_DRAWER_CONTAINER = "LANGUAGE_DRAWER_CONTAINER",
  LANGUAGE_DRAWER_TRIGGER = "language-drawer-trigger",
  CHANGE_AVATAR_BUTTON = "change-avatar-button",
  SUBMIT_PROFILE_BUTTON = "submit-profile-button",
  DELETE_PROFILE_BUTTON = "delete-profile-button",
  SAVE_LANGUAGE_BUTTON = "save-language-button",
  SAVE_AVATAR_BUTTON = "save-avatar-button",
  AVATAR_SELECTION_MODAL_CONTAINER = "AVATAR_SELECTION_MODAL_CONTAINER",
  AVATAR_BUTTONS_CONTAINER = "AVATAR_BUTTONS_CONTAINER",
  DELETE_PROFILE_MODAL_CONTAINER = "DELETE_PROFILE_MODAL_CONTAINER",
  DELETE_MODAL_CANCEL_BUTTON = "delete-modal-cancel-button",
  DELETE_MODAL_CONFIRM_BUTTON = "delete-modal-confirm-button",
  CREATE_PROFILE_FOOTER = "CREATE_PROFILE_FOOTER",
  MOBILE_NUMBER_INPUT = "mobile-number-input",
  SEND_OTP_CONTAINER = "send-otp-container",
  BACK_CONFIRMATION_DRAWER_CONTAINER = "BACK_CONFIRMATION_DRAWER_CONTAINER",
  BACK_CONFIRMATION_CANCEL_BUTTON = "back-confirmation-cancel-button",
  BACK_CONFIRMATION_CONFIRM_BUTTON = "back-confirmation-confirm-button",
  BACK_BUTTON_OTP = "back-button-otp",
  LOGIN_KEYBOARD_KEY_1 = "1",
  TV_KEYBOARD_KEY_CLEAR = "Clear",
  SEND_OTP_BUTTON_NEW = "send-otp-button-new",
  SEND_OTP_BUTTON = "send-otp-button",
  // Settings Focus Keys
  AUTH_SWITCH = "auth-switch",
}

export const focusKeyHelper = {
  getCarouselItemFocusKey: (index: number) => {
    return `CAROUSEL_ITEM_${index}`;
  },
  getCultureSelectionItemFocusKey: (cultureAbbreviation: string) => {
    return `culture-${cultureAbbreviation}`;
  },
  getLanguageDrawerOptionFocusKey: (langKey: string) => {
    return `language-${langKey}`;
  },
};
